/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import {SearchManager} from './search-manager';
import {SearchTag} from '../../model/search-tag';
import {EventEmitter} from '@angular/core';
import {Observer, Subscription} from 'rxjs';

export class DataSearchManager extends SearchManager {
  public data: any;
  private sendClose = new EventEmitter();

  constructor(tags?: SearchTag[]) {
    super();
    if (!tags) {
      tags = [];
    }
    this.data = {};
    this.tags = tags;
    for (const tag of tags) {
      this.data[tag.name] = tag.value;
    }
  }

  protected getData() {
    return this.data;
  }

  protected generateTags() {
    for (const prop in this.data) {
      const found = this.tags.find((tag) => tag.name === prop);
      if (found) {
        found.value = this.data[prop];
      } else {
        const tag = new SearchTag(prop, prop, this.data[prop]);
        this.addTag(tag);
      }
    }
  }

  protected updateData(tag: SearchTag) {
    this.data[tag.name] = tag.value;
  }

  public closeMenu() {
    this.sendClose.emit();
  }

  public subscribe(next?: Partial<Observer<any>> | ((value: any) => void), error?: (error: any) => void, complete?: () => void)
    : Subscription {
    return this.sendClose.subscribe(next, error, complete);
   }
}
